<template>
    <div class="app-container">
        <el-card>
            <div v-loading="tableLoading">
                <el-table class="grayTableTile_01" :data="datasList.rows" style="width: 100%;margin-bottom: 20px;" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
                    <template v-for="(item,index) in datasList.threads">
                        <el-table-column v-if="item.show" :label="item.name" :property="item.sortProperty" show-overflow-tooltip :sortable="item.sortFlag ? 'custom' : false">
                            <template slot-scope="scope">
                                <span>{{scope.row[item.property]}}</span>
                            </template>
                        </el-table-column>
                    </template>

                    <el-table-column prop="address" label="操作" fixed="right" width="150">
                        <template slot-scope="scope">
                            <el-link :underline="false" type="primary" @click="editLabel(scope.row)">编辑</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <el-dialog :visible.sync="labelDia" >
            <div slot="title" ref="addLabelRef"></div>
            <span>value:</span>
            <el-input  v-model="editForm.value"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="labelDia = false">取 消</el-button>
                <el-button type="primary" @click="handleEdit">确 定</el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
  import {debounce} from 'lodash'
  import { queryBy_searchForm,update_byForm} from '@Dcs~/api/editManage'

  export default {
    data() {
      return {

        baseZoom: 1,
        labelDia: false,
        editForm: {},
        tableLoading:false,
        datasList: {
          rows: [],
          threads: []
        }

      }
    },
    mounted() {
      this.getList()

    },
    methods: {

      getList() {
        this.tableLoading = true
        queryBy_searchForm().then((res)=>{
          if(res.code==1){
            for (let key in res.data[0]) {
              if(this.datasList.threads.length<Object.keys(res.data[0]).length){
                this.datasList.threads.push({name:key,property:key,sortFlag:false,sortProperty:key,show:true})
              }
            }
            this.datasList.rows = res.data
            this.tableLoading = false
          }
        })
      },

      handleEdit(){
        update_byForm(this.editForm).then((res)=>{
          if(res.code==1){
            this.$message({
              message: '编辑成功',
              type: 'success',
            })
            this.getList()
            this.labelDia = false
          }
        })

      },

      editLabel(row){
        this.labelDia = true
        this.editForm = row
      },

    }
  }
</script>
<style lang="scss" scoped>

</style>
